
export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return " Dit is een eigen product, eigen producten kan je beheren via het menu punt 'Eigen producten'. "
}